import React, { useEffect, useState, lazy, Suspense } from "react";
import axios from "axios";
import toastr from "../../utils/toast";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import { Client_View } from "../../utils/sweetalert";
import { openInAppTab } from "../../utils/tabNavigation";
import useSmartBack from "../../hooks/useSmartBack";
import CompensationAdd from "../../components/Modals/Candidate/CompensationAdd";
import NewReferenceForm from "../../components/Modals/Candidate/NewCandidateRefform";
const modals = {
  ReferenceForm: lazy(
    () => import("../../components/Modals/Candidate/Candidaterefform"),
  ),
  BasicDetailUpadte: lazy(
    () => import("../../components/Modals/Candidate/BasicDetailUpadte"),
  ),
  EditContactModal: lazy(
    () => import("../../components/Modals/Candidate/EditContactModal"),
  ),
  AddCompanyInfoModal: lazy(
    () => import("../../components/Modals/Candidate/AddCompanyInfoModal"),
  ),
  AddNotesModal: lazy(
    () => import("../../components/Modals/Candidate/AddNotesModal"),
  ),
  UploadFileRole: lazy(
    () => import("../../components/Modals/Candidate/AddMediaModal"),
  ),
  AddRecordingModal: lazy(
    () => import("../../components/Modals/Candidate/AddRecordingModal"),
  ),
  EditCompanyInfoModal: lazy(
    () => import("../../components/Modals/Candidate/EditCompanyInfoModal"),
  ),
  EditSummaryModal: lazy(
    () => import("../../components/Modals/Candidate/EditSummaryModal"),
  ),
  AddEducationModal: lazy(
    () => import("../../components/Modals/Candidate/AddEducationModal"),
  ),
  LushaModal: lazy(
    () => import("../../components/Modals/Candidate/LushaModal"),
  ),
  ShowTranscriptionModal: lazy(
    () => import("../../components/Modals/Candidate/ShowTranscriptionModal"),
  ),
  GenerateDossierModal: lazy(
    () => import("../../components/Modals/Candidate/GenerateDossierModal"),
  ),
};

function Candidate() {
  const { id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const REACT_APP_BASE_URL_BACK = process.env.REACT_APP_BASE_URL_BACK;
  const [data, setData] = useState([]);
  const [skills, setSkills] = useState([]);
  const [experiance, setExperiance] = useState([]);
  const [education, setEducation] = useState([]);
  const [roles, setRoles] = useState([]);
  const [compensation, setCompensation] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [refcheck, setRefcheck] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [CandidaterefModal, setCandidaterefModal] = useState(false);
  const [CandidateNewRefModal, setCandidateNewRefModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [flag, setFlag] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [companyinfos, setCompanyinfos] = useState("");
  const [canEdit, setCanEdit] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showRecordingModal, setShowRecordingModal] = useState(false);
  const [selectedRecordingRoleId, setSelectedRecordingRoleId] = useState(null);
  const [showEditCompanyModal, setShowEditCompanyModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [lushaFlag, setLushaFlag] = useState(null);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [summary, setSummary] = useState("");
  const [gptSummary, setGptSummary] = useState("");
  const [showEducationModal, setShowEducationModal] = useState(false);
  const [isLushaLoading, setIsLushaLoading] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [lushaPhone, setLushaPhone] = useState(null);
  const [lushaEmail, setLushaEmail] = useState(null);
  const [lastChecked, setLastChecked] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const navigate = useNavigate();
  const handleBack = useSmartBack(
    "/business_intelligence/new_search_candidates",
  );
  const [compModel, setCompModel] = useState(false);
  const [showTranscriptionModal, setShowTranscriptionModal] = useState(false);
  const [selectedTranscript, setSelectedTranscript] = useState("");
  const [isGeneratingDossier, setIsGeneratingDossier] = useState(false);
  const [showDossierModal, setShowDossierModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [sectionsLoading, setSectionsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);

  const openNotesModal = async () => {
    try {
      setGlobalLoading(true);

      const response = await axios.get(
        `${API_BASE_URL}/candidates/get_transcription/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setSelectedTranscript(response.data.transcription);
      setShowTranscriptionModal(true);
    } catch (error) {
      console.error("Error fetching transcription:", error);
      toastr.error("Failed to load transcription.");
    } finally {
      setGlobalLoading(false);
    }
  };

  const user = JSON.parse(localStorage.getItem("user")) || {};

  async function fetchOptions(silent = false) {
    if (!silent) setSectionsLoading(true); //  Show loader before API call
    try {
      const response = await axios.get(
        `${API_BASE_URL}/candidates/get_candidates_details/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log("Documents", response.data.emp_detail[4].data);
      setData(response.data.emp_detail[0].data || []);
      setSkills(response.data.emp_detail[1].data || []);
      setExperiance(response.data.emp_detail[2].data || []);
      setEducation(response.data.emp_detail[3].data || []);
      setRoles(response.data.emp_detail[4].data || []);
      setCompensation(response.data.emp_detail[5].data || []);
      setDocuments(response.data.emp_detail[6].data || []);
      console.log(response.data.emp_detail[6].data);

      setRefcheck(response.data.emp_detail[7].data || []);
    } catch (error) {
      console.error("API Error:", error);
      setData([]); // Prevent errors from breaking UI
      setSkills([]);
      setExperiance([]);
      setEducation([]);
      setRoles([]);
      setCompensation([]);
      setDocuments([]);
      setRefcheck([]);
    } finally {
      setSectionsLoading(false);
    }
  }

  useEffect(() => {
    fetchOptions();
  }, [id]);

  const loadData = async () => {
    try {
      setGlobalLoading(true);
      fetchOptions();
    } catch (err) {
      console.log(err);
    } finally {
      setGlobalLoading(false);
    }
  };

  // Filter only audio/mpeg files
  const audioFiles = documents.filter((doc) => doc.type === "audio/mpeg");

  function calculateExperience(start_date, end_date = null) {
    let startDate = new Date(start_date);
    let endDate = end_date ? new Date(end_date) : new Date(); // Use current date if end_date is empty

    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();

    // Adjust if months go negative
    if (months < 0) {
      years -= 1;
      months += 12;
    }

    return { years, months };
    // return `${years} years and ${months} months`;
  }

  const currencyClassMap = {
    1: "ti ti-currency-rupee",
    2: "ti ti-currency-dollar",
    3: "ti ti-currency-pound",
    4: "ti ti-currency-dollar-australian",
    5: "ti ti-currency-peso",
    6: "ti ti-currency-yuan",
    7: "ti ti-currency-dollar-singapore",
    8: "ti ti-currency-dollar-singapore",
    9: "ti ti-currency-dollar-singapore",
  };

  // console.log(calculateExperience("2022-04-02", "2024-05-04"));

  useEffect(() => {
    if (showEditModal) {
      console.log("Edit modal opened");
    } else {
      console.log("Edit modal closed");
    }
  }, [showEditModal]);

  const handleUpdateFlag = async (e) => {
    e.preventDefault();
    if (isUpdating) return; // extra guard, belt-and-suspenders with the disabled button below
    setIsUpdating(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/candidates/update_candidate_flag`,
        { candidate_id: id, flag: "4", user_id: user.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        setFlag(2);
        fetchOptions(); // update local state so UI changes immediately
      }
    } catch (error) {
      console.error("Error updating flag:", error);
      toastr.error(error.response.data.error);
    } finally {
      setIsUpdating(false);
    }
  };
  useEffect(() => {
    const checkEditPermission = async (roleId) => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/candidates/check_edit_permission/${roleId}/${user.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setCanEdit((prev) => ({
          ...prev,
          [roleId]: response.data.canEdit,
        }));
      } catch (error) {
        console.error("Permission check failed for role:", roleId, error);
        setCanEdit((prev) => ({
          ...prev,
          [roleId]: false,
        }));
      }
    };

    if (roles.length && user?.id) {
      roles.forEach((role) => {
        if (role.role_id) {
          checkEditPermission(role.role_id);
        }
      });
    }
  }, [roles, user?.id]);

  useEffect(() => {
    const fetchLushaStatus = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/candidates/lusha_status/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 200 && response.data.data) {
          const { lusha_status_id, phone, created, updated, email } =
            response.data.data;

          setLushaFlag(Number(lusha_status_id));
          setLushaPhone(phone);
          setLushaEmail(email); // optional if you want to display/copy email
          setLastChecked(updated || created); // 👈 important for 6-month logic
        }
      } catch (error) {
        console.error("❌ Error fetching Lusha status:", error);
      }
    };

    fetchLushaStatus();
  }, [id]);

  // Prevent leaving the page while contacts are being requested
  useEffect(() => {
    if (!isLushaLoading) return;

    const blockUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    const blockLinks = (e) => {
      if (e.target.closest("a[href]")) {
        e.preventDefault();
        e.stopPropagation();
        toastr.warning("Please wait until the contact request completes.");
      }
    };

    window.addEventListener("beforeunload", blockUnload);
    document.addEventListener("click", blockLinks, true);
    return () => {
      window.removeEventListener("beforeunload", blockUnload);
      document.removeEventListener("click", blockLinks, true);
    };
  }, [isLushaLoading]);

  // --- Inside your component ---
  const handleUpdateLushaFlag = async () => {
    setIsLushaLoading(true); // local button / modal loader
    try {
      const payload = {
        candidate_id: id,
      };

      const response = await axios.post(
        `${API_BASE_URL}/candidates/update_candidate_contacts`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("response:", response);

      if (response.status === 200) {
        const { message, data: responseData } = response.data; // rename to avoid shadowing component `data`

        const lusha_status_id = responseData.lusha_status_id;
        // Update lusha state
        setLushaPhone(responseData.phone);
        setLushaEmail(responseData.email);
        setLushaFlag(Number(lusha_status_id));

        // ✅ Also patch the main `data` object so sidebar reflects immediately
        // without waiting for fetchOptions to complete
        if (responseData.phone || responseData.email) {
          setData((prev) => ({
            ...prev,
            phone: responseData.phone || prev.phone,
            email: responseData.email || prev.email,
          }));
        }

        // Keep the modal open only if there are contacts to review
        setShowPhoneModal(Number(lusha_status_id) === 4 && !!responseData.phone);

        fetchOptions(true); // sync everything else without showing section loaders
        toastr.success(message || "Contacts updated successfully.");
      }
    } catch (error) {
      console.error("❌ Error updating Lusha flag:", error);
      toastr.error(
        error.response?.data?.error ||
          "Failed to update Lusha flag. Please try again.",
      );
    } finally {
      setIsLushaLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      setSummary(data.summary || "");
      setGptSummary(data.gpt_summary || "");
    }
  }, [data]);

  // Callback after successfully updating summary
  const handleSummaryUpdate = (updatedSummary, updatedGptSummary) => {
    setSummary(updatedSummary);
    setGptSummary(updatedGptSummary);
    // Optionally update your main data state with new summary info
    setData((prev) => ({
      ...prev,
      summary: updatedSummary,
      gpt_summary: updatedGptSummary,
    }));
  };

  const handleEducationAdded = async () => {
    // Re-fetch or update education list after insertion
    const response = await axios.get(
      `${API_BASE_URL}/candidates/get_candidates_details/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    setEducation(response.data.emp_detail[3].data || []);
  };

  const generateWithAI = async (candidate_id) => {
    setIsGenerating(true);
    try {
      // ✅ 1. Generate base summary (from candidate details)
      const baseSummaryResponse = await axios.post(
        `${API_BASE_URL}/candidates/generatecandidatealldetail/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const baseSummary = baseSummaryResponse.data.summary;
      console.log("✅ Base summary generated successfully:", baseSummary);

      // ✅ 2. Generate AI summary
      const aiSummaryResponse = await axios.post(
        `${API_BASE_URL}/chatgpt/generate_summary/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const aiSummary = aiSummaryResponse.data.ai_summary;
      setSummary(baseSummary);
      setGptSummary(aiSummary);
      console.log("✅ AI summary generated successfully:", aiSummary);
    } catch (error) {
      if (error.response) {
        console.error(
          "Error generating base or AI summary:",
          error.response.data.error,
        );
      } else {
        console.error("Error generating base or AI summary:", error.message);
      }
    } finally {
      // 3. Reset loading state to false
      setIsGenerating(false);
    }
  };

  const handleFileDeleteClick = (compId) => {
    confirmFileDelete(compId, handleDelete);
  };

  const confirmFileDelete = (compId, onConfirmDelete) => {
    Client_View({
      title: "Are you sure?",
      text: "This compensation details will be permanently deleted.",
      icon: "warning",
      confirmButtonText: "Yes, Delete",
      confirmCallback: () => onConfirmDelete(compId),
      cancleCallback: () => {
        console.log("User cancelled deletion");
      },
    });
  };

  const handleDelete = async (compId) => {
    // if (!window.confirm("Are you sure you want to delete this entry?")) return;

    try {
      const response = await axios.get(
        `${API_BASE_URL}/candidates/delete_compensation/${compId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      loadData();
    } catch (error) {
      console.error("Delete failed", error);
      alert("Failed to delete entry");
    }
  };

  const handleTranscribeExisting = async (doc, id) => {
    setDocuments((prev) =>
      prev.map((d) =>
        d.filename === doc.filename ? { ...d, loading: true } : d,
      ),
    );
    try {
      console.log("Sending to backend:", {
        filename: doc.filename,
        candidate_id: id,
      });
      const response = await axios.post(
        `${API_BASE_URL}/chatgpt/whisper_transcribe`,
        {
          filename: doc.filename,
          candidate_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const transcript = response.data.transcript;

      // Update only that document transcription
      setDocuments((prevDocs) =>
        prevDocs.map((d) =>
          d.filename === doc.filename
            ? {
                ...d,
                transcription: transcript,
                filename: null,
                loading: false,
              }
            : d,
        ),
      );
    } catch (error) {
      console.error("Transcription failed:", error);
      alert("Failed to transcribe recording");
      setDocuments((prevDocs) =>
        prevDocs.map((d) =>
          d.filename === doc.filename ? { ...d, loading: false } : d,
        ),
      );
    } finally {
      // Reset loading in finally
      setDocuments((prev) =>
        prev.map((d) =>
          d.filename === doc.filename ? { ...d, loading: false } : d,
        ),
      );
    }
  };

  const getFolder = (typeId) => {
    switch (typeId) {
      case 1:
        return "resume";
      case 2:
        return "dossiers";
      case 3:
        return "offer_letter";
      case 8:
        return "candidate_profile";
      case 9:
        return "background";
      default:
        return "other";
    }
  };

  const [recordingUrls, setRecordingUrls] = useState({});

  const openFile = async (folder, documenttype_id, savename) => {
    const response = await fetch(
      `${REACT_APP_BASE_URL_BACK}files/${folder}/media/${documenttype_id}/${savename}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.status}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    if (documenttype_id === "recordings") {
      console.log({ url: url, response: response });
      return url;
    } else {
      window.open(url, "_blank");
    }
  };
  //imageCandidate

  useEffect(() => {
    let urls = {};

    const loadRecordingUrls = async () => {
      const audioDocs = documents.filter(
        (doc) => doc.type === "audio/mpeg" && doc.filename,
      );

      const loadedUrls = {};

      await Promise.all(
        audioDocs.map(async (doc) => {
          try {
            const url = await openFile(
              "candidates",
              "recordings",
              doc.filename,
            );

            loadedUrls[doc.id || doc.filename] = url;
          } catch (error) {
            console.error(`Failed to load recording: ${doc.filename}`, error);
          }
        }),
      );

      urls = loadedUrls;
      setRecordingUrls(loadedUrls);
    };

    if (documents?.length) {
      loadRecordingUrls();
    }

    return () => {
      Object.values(urls).forEach((url) => {
        URL.revokeObjectURL(url);
      });
    };
  }, [documents, token]);

  const Dp = async (filename) => {
    const response = await fetch(
      `${REACT_APP_BASE_URL_BACK}files/candidates/picture/${filename}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    setImageUrl(url);
  };

  useEffect(() => {
    if (!data?.userpic) return;
    console.log("img", data.userpic);
    Dp(data?.userpic);
  }, [data]);

  const SectionLoader = () => (
    <div className="d-flex justify-content-center align-items-center py-4">
      <span
        className="spinner-border spinner-border-sm text-primary"
        role="status"
        aria-hidden="true"
      ></span>
    </div>
  );

  return (
    <>
      <div className="content">
        <div className="row">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0">Candidate Details</h4>

            <button
              className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"
              style={{ cursor: "pointer", textDecoration: "none" }}
              onClick={handleBack}
            >
              <i className="ti ti-arrow-left me-1"></i>
              Back
            </button>
          </div>

          <div className="col-xl-4 theiaStickySidebar">
            <div className="ribbone-card card card-bg-1">
              <div className="ribbone ribbone-top-left text-danger">
                {roles.length > 0
                  ? roles.map((role, index) =>
                      role.candidate_status_id == "54" ? (
                        <span key={index} className="bg-gray">
                          CLOSED
                        </span>
                      ) : null,
                    )
                  : null}
              </div>
              <div className="card-body p-0">
                <span className="avatar avatar-xl avatar-rounded border border-2 border-white m-auto d-flex mb-2">
                  <img
                    src={imageUrl}
                    className="w-auto h-auto"
                    alt="Img"
                    // onError={(e) => {
                    //   if (!e.target.src.includes(PINE_BASE_URL)) {
                    //     e.target.onerror = null;
                    //     e.target.src = `${PINE_BASE_URL}/files/imageCandidates/${data.userpic}`;
                    //   }
                    // }}
                  />
                </span>
                <div className="text-center px-3 pb-3 border-bottom">
                  {sectionsLoading ? (
                    <SectionLoader />
                  ) : (
                    <>
                      <div className="mb-3">
                        <h5 className="d-flex align-items-center justify-content-center mb-1">
                          {data.full_name}
                          <i className="ti ti-discount-check-filled text-success ms-1"></i>
                          {data.linkdin_url != "" ? (
                            <a
                              href={data.linkdin_url}
                              target="_blank"
                              className="ms-2"
                            >
                              <i
                                className="fe fe-linkedin"
                                aria-label="linkedin"
                              ></i>
                            </a>
                          ) : (
                            ""
                          )}
                        </h5>
                        <span className="badge badge-soft-dark fw-medium me-2">
                          <i className="ti me-1"></i>
                          {data.designation}
                        </span>
                        <span className="badge badge-soft-secondary fw-medium">
                          {data.current_company}
                        </span>
                      </div>
                      <div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <span className="d-inline-flex align-items-center">
                            <i className="ti ti-id me-2"></i>
                            Candidate ID
                          </span>
                          <p className="text-dark">{data.candidate_id}</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <span className="d-inline-flex align-items-center">
                            <i className="ti ti-star me-2"></i>
                            Company
                          </span>
                          <p className="text-dark">{data.current_company}</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="d-inline-flex align-items-center">
                            <i className="ti ti-calendar-check me-2"></i>
                            Function
                          </span>
                          <p className="text-dark">{data.dutymaster}</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="d-inline-flex align-items-center">
                            <i className="ti ti-calendar-check me-2"></i>
                            Industry
                          </span>
                          <p className="text-dark fs-13">
                            {data.industryMaster} [{data.industry}]
                          </p>
                        </div>
                        {/* <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-gender-male me-2"></i>
                        Diversity
                      </span>
                      <p className="text-dark text-end">{data.gender === 'female' ? "Yes": "No"}</p>
                    </div> */}

                        <div className="d-flex align-items-center justify-content-between">
                          <span className="d-inline-flex align-items-center">
                            <i className="ti ti-map-pin-check me-2"></i>
                            Address
                          </span>
                          <p className="text-dark text-end">
                            {data.location}, <br /> {data.country_name}
                          </p>
                        </div>
                        <div className="row gx-2 mt-3">
                          <div className="col-4">
                            <div>
                              <button
                                className="btn btn-dark w-100"
                                onClick={() => setShowEditModal(true)}
                              >
                                <i className="ti ti-edit me-1"></i>
                                <span className="fs-12">Edit</span>
                              </button>
                            </div>

                            {/* Modal Component */}
                            {showEditModal && (
                              <Suspense fallback={<div>Loading</div>}>
                                <modals.BasicDetailUpadte
                                  candidateId={id}
                                  candidateData={data}
                                  Dp={imageUrl}
                                  show={showEditModal}
                                  onClose={() => setShowEditModal(false)}
                                  onSave={async () => {
                                    await fetchOptions();
                                    setShowEditModal(false);
                                  }}
                                />
                              </Suspense>
                            )}
                          </div>
                          <div className="col-8">
                            <div>
                              {Number(flag) === 4 ? (
                                <button
                                  className="btn btn-secondary w-100"
                                  disabled
                                >
                                  <i className="ti ti-clock me-1"></i>
                                  <span className="fs-12">In Queue</span>
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary w-100"
                                  onClick={handleUpdateFlag}
                                  disabled={isUpdating}
                                >
                                  {isUpdating ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm me-1"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span className="fs-12">Updating...</span>
                                    </>
                                  ) : (
                                    <>
                                      <i className="ti ti-brand-linkedin me-1 text-white"></i>
                                      <span className="fs-12">Update</span>
                                    </>
                                  )}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {sectionsLoading ? (
                  <SectionLoader />
                ) : (
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6>Contact Information</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-phone me-2"></i>
                        Phone
                      </span>
                      <p className="text-dark">{data.phone}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-mail-check me-2"></i>
                        Email
                      </span>
                      <p className="text-dark">{data.email}</p>
                    </div>
                    <div className="row gx-2 mt-3">
                      <div className="col-6">
                        <button
                          className="btn btn-dark w-100 d-flex align-items-center justify-content-center py-2"
                          onClick={() => setShowContactModal(true)}
                        >
                          <i className="ti ti-edit me-1"></i>
                          <span className="fs-12">Edit Contact Info</span>
                        </button>

                        {showContactModal && (
                          <Suspense
                            fallback={<div>Loading Contact Editor...</div>}
                          >
                            <modals.EditContactModal
                              show={showContactModal}
                              onClose={(status) => {
                                if (status === 1) {
                                  fetchOptions();
                                }
                                setShowContactModal(false);
                              }}
                              candidateId={id}
                              candidateData={data}
                            />
                          </Suspense>
                        )}
                      </div>
                      <div className="col-6">
                        {isLushaLoading ? (
                          <button
                            className="btn btn-secondary w-100 py-2"
                            disabled
                          >
                            <i className="ti ti-loader me-1 ti-spin"></i>
                            Processing...
                          </button>
                        ) : lushaFlag === 8 ? (
                          <button
                            className="btn btn-secondary w-100 py-2"
                            disabled
                          >
                            <i className="ti ti-clock me-1"></i> In Queue
                          </button>
                        ) : lushaFlag === 4 ||
                          (lushaFlag === 1 && lushaPhone) ? (
                          <button
                            className="btn btn-success w-100 py-2"
                            onClick={() => setShowPhoneModal(true)}
                          >
                            <i className="ti ti-phone me-1 text-white"></i> View
                            Contact
                          </button>
                        ) : (
                          <button
                            className="btn btn-primary w-100 py-2"
                            style={{
                              backgroundColor: "#F97316",
                              borderColor: "#F97316",
                            }}
                            onClick={handleUpdateLushaFlag}
                          >
                            <i className="ti ti-database-import me-1 text-white"></i>{" "}
                            Update Contacts
                          </button>
                        )}

                        {showPhoneModal && (
                          <Suspense
                            fallback={<div>Loading Contact Modal...</div>}
                          >
                            <modals.LushaModal
                              key={`${lushaPhone}-${lushaEmail}`}
                              show={showPhoneModal}
                              isRequesting={isLushaLoading}
                              phoneNumbers={lushaPhone}
                              email={lushaEmail}
                              data={data}
                              created={lastChecked} // 👈 pass lastChecked (updated || created)
                              lushaFlag={lushaFlag}
                              token={token}
                              onClose={() => setShowPhoneModal(false)}
                              onRequestAgain={() => handleUpdateLushaFlag()}
                            />
                          </Suspense>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h6>Compensation Details</h6>
              <button
                onClick={() => {
                  setCompModel(true);
                }}
                className="p-0 border-0 bg-transparent"
                style={{ cursor: "pointer" }}
              >
                <i className="ti ti-edit text-primary black"></i>
              </button>
            </div>
            {compModel && (
              <CompensationAdd
                candidate_id={id}
                onClose={(status) => {
                  setCompModel(false);
                  loadData();
                }}
              />
            )}
            <div className="col-lg-12 col-md-12 d-flex">
              <div className="card flex-fill">
                {compensation.length > 0
                  ? compensation.map((compensation, index) => (
                      <div className="card-body  border-bottom">
                        <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                          <div className="d-flex align-items-center flex-column overflow-hidden">
                            <div>
                              <div>
                                <span className="fs-12 fw-normal text-truncate mb-1">
                                  {compensation.companyinfo ? (
                                    <p>{compensation.companyinfo}</p>
                                  ) : (
                                    <p>{compensation.company}</p>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <a
                              href="#"
                              className="avatar avatar-md br-5 payment-report-icon  bg-transparent-primary border border-primary"
                            >
                              <span className="text-primary">
                                <i className="fa-solid fa-coins"></i>
                              </span>
                            </a>
                          </div>
                        </div>
                        <div className="d-flex justify-content-center mt-2">
                          <div className="row align-items-center">
                            <div className="col-md-12">
                              <div className="row gy-4">
                                <div className="col-md-12">
                                  <h6 className="fs-12 text-gray-5 fw-normal side-badge-warning mb-1">
                                    {" "}
                                    Approx CTC
                                  </h6>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="fs-12 fw-bold mb-0">
                                      {compensation.currency}{" "}
                                      {new Intl.NumberFormat(
                                        compensation.currency_id == "1"
                                          ? "en-IN"
                                          : "en-US",
                                      ).format(
                                        compensation.total_ctc ??
                                          compensation.approx_ctc,
                                      )}
                                    </h5>

                                    <button
                                      onClick={() =>
                                        handleFileDeleteClick(compensation.id)
                                      }
                                      className="p-0 border-0 bg-transparent"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i className="ti ti-trash text-danger"></i>
                                    </button>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <h6 className="fs-12 text-gray-5 fw-normal side-badge mb-1">
                                    Fixed
                                  </h6>
                                  <h5 className="fs-12 fw-bold">
                                    {compensation.fixed != 0
                                      ? new Intl.NumberFormat(
                                          compensation.currency_id === "1"
                                            ? "en-IN"
                                            : "en-US",
                                        ).format(compensation.fixed)
                                      : "NA"}
                                  </h5>
                                </div>
                                <div className="col-md-4">
                                  <h6 className="fs-12 text-gray-5 fw-normal side-badge-pink mb-1">
                                    {" "}
                                    Variable
                                  </h6>
                                  <h5 className="fs-12 fw-bold">
                                    {compensation.variable != 0
                                      ? new Intl.NumberFormat(
                                          compensation.currency_id === "1"
                                            ? "en-IN"
                                            : "en-US",
                                        ).format(compensation.variable)
                                      : "NA"}
                                  </h5>
                                </div>
                                <div className="col-md-4">
                                  <h6 className="fs-12 text-gray-5 fw-normal side-badge-purple mb-1">
                                    {" "}
                                    Others
                                  </h6>
                                  <h5 className="fs-12 fw-bold">
                                    {compensation.others != 0
                                      ? new Intl.NumberFormat(
                                          compensation.currency_id === "1"
                                            ? "en-IN"
                                            : "en-US",
                                        ).format(compensation.others)
                                      : "NA"}{" "}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  : ""}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between mb-2">
              <h6>Documents</h6>
              <div className="d-flex align-items-center gap-2">
                {/* 🧾 Create Dossier Button */}
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => setShowDossierModal(true)}
                >
                  Create Dossier
                </button>
                <button
                  className="btn btn-sm btn-outline-primary me-2"
                  onClick={() => {
                    setSelectedRecordingRoleId(null);
                    setShowRecordingModal(true);
                  }}
                >
                  <i className="ti ti-microphone me-1"></i>
                  Upload Recording
                </button>
                {/* ⬆ Upload Button */}
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setShowUploadModal(true);
                  }}
                  className="p-0 border-0 bg-transparent"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ti ti-upload text-primary black"></i>
                </button>
              </div>
              {CandidateNewRefModal && (
                <NewReferenceForm
                  onclose={() => {
                    setCandidateNewRefModal(false);
                    fetchOptions();
                  }}
                  refcandidateid={selectedCandidateId}
                  candidate_id={id}
                />
              )}
              {showUploadModal && (
                <Suspense fallback={<div>Loading Upload Dialog...</div>}>
                  <modals.UploadFileRole
                    show={showUploadModal}
                    roleId={roles.role_id}
                    roles={roles}
                    candidateId={id}
                    token={token}
                    refreshFiles={loadData}
                    onClose={() => setShowUploadModal(false)}
                  />
                </Suspense>
              )}
              {showDossierModal && (
                <Suspense fallback={<div>Loading Dossier Dialog...</div>}>
                  <modals.GenerateDossierModal
                    show={showDossierModal}
                    candidateId={id}
                    onClose={() => setShowDossierModal(false)}
                    onGenerated={loadData}
                    roles={roles}
                  />
                </Suspense>
              )}
              {showRecordingModal && (
                <Suspense fallback={<div>Loading Recording Tool...</div>}>
                  <modals.AddRecordingModal
                    show={showRecordingModal}
                    candidate_id={id}
                    user={user.id}
                    roles={roles}
                    initialRoleId={selectedRecordingRoleId}
                    onClose={(status) => {
                      if (status === 1) {
                        fetchOptions();
                      }

                      setShowRecordingModal(false);
                      setSelectedRecordingRoleId(null);
                    }}
                  />
                </Suspense>
              )}
            </div>
            <div className="card">
              <div className="card-body p-0">
                {documents.length === 0 && (
                  <p className="p-3">No documents found.</p>
                )}

                {documents
                  .filter((doc) => doc.type !== "audio/mpeg")
                  .map((doc, idx) => (
                    <div
                      key={idx}
                      className="p-3 border-bottom d-flex justify-content-between align-items-center"
                    >
                      <div className="d-flex align-items-center">
                        <strong>{doc.documentName}</strong>&nbsp;
                        {/* Role indicator icon */}
                        {doc.role_name && (
                          <i
                            className="ti ti-briefcase text-primary ms-1 me-2"
                            style={{ cursor: "pointer" }}
                            title={`Role: ${doc.role_name}`}
                          ></i>
                        )}
                        <button
                          className="btn btn-outline-primary btn-sm d-flex align-items-center"
                          onClick={() => {
                            openFile(
                              "candidates",
                              getFolder(doc.documenttype_id),
                              doc.savename,
                            );
                          }}
                        >
                          📄 View File
                        </button>
                      </div>
                      <small className="text-muted">{doc.date}</small>
                    </div>
                  ))}

                {documents
                  .filter((doc) => doc.type === "audio/mpeg")
                  .map((doc, idx) => {
                    const recordingUrl = recordingUrls[doc.id || doc.filename];

                    return (
                      <div
                        key={doc.id || idx}
                        className="p-3 border-bottom d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <strong>
                            Assessment Recording For {doc.role_name}
                          </strong>

                          {doc.filename && (
                            <>
                              <div>
                                {recordingUrl ? (
                                  <audio
                                    controls
                                    style={{
                                      width: "250px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    <source
                                      src={recordingUrl}
                                      type={doc.type}
                                    />
                                    Your browser does not support the audio
                                    element.
                                  </audio>
                                ) : (
                                  <span className="text-muted">
                                    Loading recording...
                                  </span>
                                )}
                              </div>

                              <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() =>
                                  handleTranscribeExisting(doc, id)
                                }
                                disabled={doc.loading}
                              >
                                {doc.loading ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Generating...
                                  </>
                                ) : (
                                  "📝 Generate Notes"
                                )}
                              </button>
                            </>
                          )}

                          {!doc.filename && doc.transcription && (
                            <div className="mt-2">
                              <button
                                className="btn btn-sm btn-success"
                                onClick={openNotesModal}
                              >
                                📄 Show Transcription
                              </button>
                            </div>
                          )}
                        </div>

                        <small className="text-muted">{doc.date}</small>
                      </div>
                    );
                  })}

                <Suspense fallback={null}>
                  <modals.ShowTranscriptionModal
                    show={showTranscriptionModal}
                    onClose={() => setShowTranscriptionModal(false)}
                    candidateId={id}
                    initialTranscription={selectedTranscript}
                    onUpdate={(updatedText) => {
                      setDocuments((prevDocs) =>
                        prevDocs.map((doc) =>
                          doc.candidate_id === id
                            ? { ...doc, transcription: updatedText }
                            : doc,
                        ),
                      );
                    }}
                  />
                </Suspense>
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            <div>
              <div className="tab-content custom-accordion-items">
                <div
                  className="tab-pane active show"
                  id="bottom-justified-tab1"
                  role="tabpanel"
                >
                  <div
                    className="accordion accordions-items-seperate"
                    id="accordionExample"
                  >
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingOne">
                        <div className="accordion-button d-flex align-items-center flex-fill">
                          <h5>
                            {gptSummary
                              ? "AI Generated Summary"
                              : summary
                                ? "LinkedIn Summary"
                                : "Please Write Your Summary"}
                          </h5>

                          <button
                            className="btn btn-sm btn-icon ms-auto"
                            onClick={() => setShowSummaryModal(true)}
                            type="button"
                          >
                            <i className="ti ti-edit"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-primary ms-2" // Added margin for spacing
                            onClick={() => generateWithAI()} // You can define this function to trigger AI generation
                            type="button"
                            disabled={isGenerating} // Disable the button while generating
                          >
                            {isGenerating ? (
                              // Show 'Generating...' with a spinner
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Generating...
                              </>
                            ) : (
                              // Show default text
                              "Generate With AI"
                            )}
                          </button>
                        </div>
                      </div>
                      <div
                        id="primaryBorderOne"
                        className="show border-top"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div
                          className="accordion-body mt-2 slimscroll"
                          style={{
                            maxHeight: "10rem",
                            minHeight: "10rem",
                            overflow: "auto",
                          }}
                        >
                          {gptSummary ? gptSummary : summary}
                        </div>
                      </div>
                    </div>

                    {/* Edit Summary Modal */}

                    {showSummaryModal && (
                      <Suspense fallback={<div>Loading Summary Editor...</div>}>
                        <modals.EditSummaryModal
                          show={showSummaryModal}
                          onClose={(
                            status,
                            updatedSummary,
                            updatedGptSummary,
                          ) => {
                            if (status === 1) {
                              handleSummaryUpdate(
                                updatedSummary,
                                updatedGptSummary,
                              );
                            }
                            setShowSummaryModal(false); // ✅ always close modal
                          }}
                          candidateId={id}
                          initialSummary={summary}
                          initialGptSummary={gptSummary}
                          token={token}
                          API_BASE_URL={API_BASE_URL}
                          onUpdate={handleSummaryUpdate}
                        />
                      </Suspense>
                    )}

                    <div className="accordion-item">
                      <div className="accordion-header" id="headingTwo">
                        <div className="accordion-button">
                          <div className="d-flex align-items-center flex-fill">
                            <h5>Skills and Key Word Tags:</h5>
                            {/* <a href="javascript:void(0)" className="btn btn-sm btn-icon ms-auto" data-bs-toggle="modal" data-bs-target="#edit_bank">
                              <i className="ti ti-edit"></i>
                            </a> */}
                            <a
                              href="javascript:void(0)"
                              className="d-flex align-items-center collapsed collapse-arrow"
                              data-bs-toggle="collapse"
                              data-bs-target="#primaryBorderTwo"
                              aria-expanded="false"
                              aria-controls="primaryBorderTwo"
                            >
                              <i className="ti ti-chevron-down fs-18"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="primaryBorderTwo"
                        className="accordion-collapse collapse border-top"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <div className="row">
                            <div className="card-body d-flex flex-wrap gap-2">
                              {sectionsLoading ? (
                                <SectionLoader />
                              ) : skills.length > 0 ? (
                                skills.map((skill, index) => (
                                  <span
                                    key={index}
                                    className="badge bg-outline-dark text-dark"
                                  >
                                    {skill.skill_name}
                                  </span>
                                ))
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingThree">
                        <div className="accordion-button">
                          <div className="d-flex align-items-center justify-content-between flex-fill">
                            <h5>Employment History</h5>
                            <div className="d-flex">
                              <button
                                className="btn btn-dark w-100 "
                                onClick={() => setShowCompanyModal(true)}
                              >
                                <i className="ti ti-plus me-1"></i>{" "}
                                {/* Icon with margin to the right */}
                                <span className="fs-12">
                                  Add Experience
                                </span>{" "}
                                {/* Text with font size 12 */}
                              </button>

                              {showCompanyModal && (
                                <Suspense
                                  fallback={
                                    <div>Loading Company Info Form...</div>
                                  }
                                >
                                  <modals.AddCompanyInfoModal
                                    show={showCompanyModal}
                                    onClose={(status) => {
                                      if (status === 1) {
                                        fetchOptions();
                                      }
                                      setShowCompanyModal(false);
                                    }}
                                    candidateId={id}
                                    candidateData={companyinfos}
                                    token={token}
                                  />
                                </Suspense>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="primaryBorderThree"
                        className="show border-top"
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample"
                      >
                        <div
                          className="accordion-body slimscroll"
                          style={{
                            maxHeight: 21 + "rem",
                            minHeight: 10 + "rem",
                            overflow: "auto",
                          }}
                        >
                          <div className="row">
                            {sectionsLoading ? (
                              <SectionLoader />
                            ) : experiance.length > 0 ? (
                              experiance.map((experiances, index) => (
                                <div key={index} className="col-md-12 d-flex">
                                  <div
                                    className="card flex-fill"
                                    style={{ marginBottom: 0.5 + "rem" }}
                                  >
                                    <div
                                      className="card-body"
                                      style={{
                                        paddingTop: 0.5 + "rem",
                                        paddingBottom: 0.5 + "rem",
                                      }}
                                    >
                                      <div className="row align-items-center">
                                        <div className="col-md-7">
                                          <div className="d-flex align-items-center">
                                            <img
                                              src={
                                                experiances.logo
                                                  ? `${REACT_APP_BASE_URL_BACK}files/companyLogo/${experiances.logo}`
                                                  : `${REACT_APP_BASE_URL_BACK}files/companyLogo/nologo.png`
                                              }
                                              width="55px;"
                                              className="img-fluid"
                                              alt="Img"
                                              style={{
                                                paddingRight: 0.2 + "rem",
                                              }}
                                            />
                                            <div>
                                              <h6 className="mb-1">
                                                <a href="#">
                                                  {" "}
                                                  {experiances.designation}
                                                </a>
                                              </h6>
                                              <div className="d-flex align-items-center">
                                                <p>
                                                  <span className="text-primary">
                                                    {experiances.company}
                                                  </span>
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div>
                                            <span className="mb-1 d-block">
                                              {experiances.start_date} to{" "}
                                              {experiances.end_date
                                                ? `${experiances.end_date}`
                                                : "Present"}
                                            </span>
                                            {(() => {
                                              const { years, months } =
                                                calculateExperience(
                                                  experiances.start_date,
                                                  experiances.end_date,
                                                );
                                              return `${years} years ${months} months`;
                                            })()}
                                          </div>
                                        </div>
                                        <div className="col-md-1">
                                          <div>
                                            <button
                                              onClick={() => {
                                                console.log(
                                                  "Selected Company Data:",
                                                  experiances,
                                                );
                                                setSelectedCompany(experiances);
                                                setShowEditCompanyModal(true);
                                              }}
                                              className="p-0 border-0 bg-transparent"
                                              style={{ cursor: "pointer" }}
                                            >
                                              <i className="ti ti-edit text-primary black"></i>
                                            </button>
                                          </div>

                                          {showEditCompanyModal && (
                                            <Suspense
                                              fallback={
                                                <div>
                                                  Loading Company Editor...
                                                </div>
                                              }
                                            >
                                              <modals.EditCompanyInfoModal
                                                show={showEditCompanyModal}
                                                onClose={() =>
                                                  setShowEditCompanyModal(false)
                                                }
                                                candidateId={id}
                                                companyInfo={selectedCompany}
                                                token={token}
                                              />
                                            </Suspense>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="accordion-item">
                          <div className="row">
                            <div className="accordion-header" id="headingFour">
                              <div className="accordion-button">
                                <div className="d-flex align-items-center justify-content-between flex-fill">
                                  <h5>Education</h5>
                                  <div className="d-flex">
                                    {/* Add Education Button */}
                                    <button
                                      className="btn btn-icon btn-sm"
                                      onClick={() =>
                                        setShowEducationModal(true)
                                      }
                                      type="button"
                                    >
                                      <i className="ti ti-plus"></i>
                                    </button>

                                    {/* Collapse Toggle */}
                                    <button
                                      className="btn btn-icon btn-sm collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#primaryBorderFour"
                                      aria-expanded="false"
                                      aria-controls="primaryBorderFour"
                                    >
                                      <i className="ti ti-chevron-down fs-18"></i>
                                    </button>
                                  </div>
                                </div>

                                {/* Add Education Modal (React controlled) */}
                                {showEducationModal && (
                                  <Suspense
                                    fallback={
                                      <div>Loading Education Form...</div>
                                    }
                                  >
                                    <modals.AddEducationModal
                                      show={showEducationModal}
                                      onClose={() =>
                                        setShowEducationModal(false)
                                      }
                                      candidateId={id}
                                      token={token}
                                      API_BASE_URL={API_BASE_URL}
                                      onAdded={handleEducationAdded}
                                    />
                                  </Suspense>
                                )}
                              </div>
                            </div>
                            <div
                              id="primaryBorderFour"
                              className="accordion-collapse collapse border-top"
                              aria-labelledby="headingFour"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                <div>
                                  {sectionsLoading ? (
                                    <SectionLoader />
                                  ) : education.length > 0 ? (
                                    education.map((education, index) => (
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <div>
                                            <span className="d-inline-flex align-items-center fw-normal">
                                              {education.school_name}
                                            </span>
                                            <h6 className="d-flex align-items-center mt-1">
                                              {education.field_of_study}
                                            </h6>
                                          </div>
                                          <p className="text-dark">
                                            {education.start_year} -{" "}
                                            {education.end_year}
                                          </p>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="accordion-item">
                          <div className="row">
                            <div className="accordion-header" id="headingFive">
                              <div className="accordion-button collapsed">
                                <div className="d-flex align-items-center justify-content-between flex-fill">
                                  <h5>Reference Check</h5>
                                  <div className="d-flex">
                                    <button
                                      className="btn btn-icon btn-sm"
                                      onClick={() =>
                                        setCandidateNewRefModal(true)
                                      }
                                      type="button"
                                    >
                                      <i className="ti ti-plus"></i>
                                    </button>
                                    <a
                                      href={`/candidates/getRefCheck/${data.id}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={(event) => {
                                        event.preventDefault();
                                        openInAppTab(
                                          `/candidates/getRefCheck/${data.id}`,
                                        );
                                      }}
                                      className="btn btn-icon btn-sm"
                                    >
                                      <i
                                        className="ti ti-users"
                                        title="Possible Referee List"
                                      ></i>
                                    </a>
                                    <a
                                      href="javascript:void(0)"
                                      className="d-flex align-items-center collapsed collapse-arrow"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#primaryBorderFive"
                                      aria-expanded="false"
                                      aria-controls="primaryBorderFive"
                                    >
                                      <i className="ti ti-chevron-down fs-18"></i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              id="primaryBorderFive"
                              className="accordion-collapse collapse border-top"
                              aria-labelledby="headingFive"
                              data-bs-parent="#accordionExample"
                            >
                              <div
                                className="accordion-body slimscroll"
                                style={{
                                  maxHeight: 15 + "rem",
                                  minHeight: 10 + "rem",
                                  overflow: "auto",
                                }}
                              >
                                <div>
                                  {refcheck.length > 0
                                    ? refcheck.map((refcheck, index) => (
                                        <div className="mb-3">
                                          <div className="d-flex align-items-center justify-content-between">
                                            <div>
                                              <span className="d-inline-flex align-items-center fw-normal">
                                                <img
                                                  className="avatar avatar-sm rounded-circle me-2"
                                                  src={`${REACT_APP_BASE_URL_BACK}files/imageCandidate/${refcheck.userpic}`}
                                                  alt="Img"
                                                />
                                                <a
                                                  href="javascript:void(0)"
                                                  onClick={() => {
                                                    setCandidaterefModal(true);
                                                    setSelectedCandidateId(
                                                      refcheck.id,
                                                    );
                                                  }}
                                                  title="View Comments"
                                                >
                                                  {refcheck.firstname}{" "}
                                                  {refcheck.lastname}
                                                </a>
                                              </span>
                                            </div>
                                            <p className="d-flex align-items-center mt-1">
                                              <h6>{refcheck.attribute}</h6>
                                            </p>
                                            <p className="text-dark">
                                              {refcheck.date}
                                            </p>
                                          </div>
                                        </div>
                                      ))
                                    : ""}
                                  {CandidaterefModal && (
                                    <Suspense
                                      fallback={
                                        <div>Loading Reference Form...</div>
                                      }
                                    >
                                      <modals.ReferenceForm
                                        onclose={() =>
                                          setCandidaterefModal(false)
                                        }
                                        refcandidateid={selectedCandidateId}
                                        candidate_id={id}
                                      />
                                    </Suspense>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingThree">
                        <div className="accordion-button">
                          <div className="d-flex align-items-center justify-content-between flex-fill">
                            <h5>Roles Assigned To</h5>
                          </div>
                        </div>
                      </div>
                      <div
                        id="primaryBorderThree"
                        className="show border-top"
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample"
                      >
                        <div
                          className="accordion-body slimscroll"
                          style={{
                            maxHeight: 28 + "rem",
                            minHeight: 10 + "rem",
                            overflow: "auto",
                          }}
                        >
                          <div className="row">
                            {roles.length > 0
                              ? roles.map((roles, index) => (
                                  <div className="col-md-12 d-flex">
                                    <div className="card flex-fill">
                                      <div className="card-body">
                                        <div className="row align-items-center">
                                          <div className="col-md-8">
                                            <div className="d-flex align-items-center">
                                              <a
                                                href={`/candidates/viewlog/${data.id}`} onClick={(e) => { e.preventDefault(); openInAppTab(`/candidates/viewlog/${data.id}`); }}
                                                target="_blank"
                                                className="flex-shrink-0 me-2"
                                              >
                                                <img
                                                  src={`${REACT_APP_BASE_URL_BACK}files/companyLogo/${roles.logo}`}
                                                  width="75px;"
                                                  className="img-fluid"
                                                  alt="Img"
                                                />
                                              </a>
                                              <div>
                                                <h6 className="mb-1">
                                                  <a
                                                href={`/role/view/${roles.role_id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    onClick={(event) => {
                                                      event.preventDefault();
                                                      openInAppTab(
                                                        `/role/view/${roles.role_id}`,
                                                      );
                                                    }}
                                                  >
                                                    {roles.role}
                                                  </a>
                                                </h6>
                                                <div className="d-flex flex-column align-items-start">
                                                  <p className="mb-1">
                                                    <span className="text-primary">
                                                      {roles.status}
                                                      <i className="ti ti-point-filled text-primary mx-1"></i>
                                                    </span>
                                                    {roles.last_update}
                                                  </p>

                                                  {roles.doj !== null && (
                                                    <p className="mb-0">
                                                      <span className="text-primary">DOJ: </span>
                                                      {roles.doj}
                                                    </p>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-md-3">
                                            <div>
                                              <span className="mb-1 d-block">
                                                Assigned to
                                              </span>
                                              <a
                                                href={`/candidates/viewlog/${data.id}`} onClick={(e) => { e.preventDefault(); openInAppTab(`/candidates/viewlog/${data.id}`); }}
                                                target="_blank"
                                                className="fw-normal d-flex align-items-center"
                                              >
                                                <img
                                                  className="avatar avatar-sm rounded-circle me-2"
                                                  src={`${REACT_APP_BASE_URL_BACK}files/media/${roles.userpic}`}
                                                  alt="Img"
                                                />
                                                {roles.firstname}
                                              </a>
                                            </div>
                                          </div>
                                          <div className="col-md-1">
                                            <>
                                              {/* Backdrop to detect outside clicks */}
                                              {openDropdownId ===
                                                roles.role_id && (
                                                <div
                                                  onClick={() =>
                                                    setOpenDropdownId(null)
                                                  }
                                                  style={{
                                                    position: "fixed",
                                                    inset: 0,
                                                    zIndex: 999,
                                                    background: "transparent",
                                                  }}
                                                ></div>
                                              )}

                                              <div className="dropdown d-flex flex-column align-items-center gap-2 position-relative">
                                                <Link
                                                  to={`/candidates/viewlog/${data.id}`}
                                                  className="d-inline-flex align-items-center"
                                                  title="View Logs"
                                                >
                                                  <i className="ti ti-info-circle"></i>
                                                </Link>
                                                <Link
                                                  to="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();

                                                    if (
                                                      canEdit[roles.role_id]
                                                    ) {
                                                      // ✅ Navigate if allowed
                                                      window.location.href = `/candidates/edit_status/${roles.role_id}/${id}`;
                                                    } else {
                                                      // ❌ Show toastr alert
                                                      toastr.error(
                                                        "You don't have permission to edit the status.",
                                                        "Access Denied",
                                                      );
                                                    }
                                                  }}
                                                  title="Edit Candidate Status"
                                                >
                                                  <i className="ti ti-edit me-1"></i>
                                                </Link>
                                                {/* Delete / Revert Toggle Button */}
                                                <Link
                                                  to="#"
                                                  onClick={async (e) => {
                                                    e.preventDefault();

                                                    try {
                                                      const response =
                                                        await fetch(
                                                          `${API_BASE_URL}/workstation/delete/${roles.cf_id}/${roles.role_id}`,
                                                          {
                                                            method: "POST",
                                                            headers: {
                                                              Authorization: `Bearer ${token}`,
                                                              "Content-Type":
                                                                "application/json",
                                                            },
                                                          },
                                                        );

                                                      const result =
                                                        await response.json();

                                                      if (result.success) {
                                                        toastr.success(
                                                          result.message,
                                                        );
                                                        loadData();
                                                      } else {
                                                        toastr.error(
                                                          result.message ||
                                                            "Something went wrong.",
                                                        );
                                                      }
                                                    } catch (err) {
                                                      console.error(
                                                        "Delete/Revert error:",
                                                        err,
                                                      );
                                                      toastr.error(
                                                        "Request failed. Please try again.",
                                                      );
                                                    }
                                                  }}
                                                  title={
                                                    roles.deleted == 1
                                                      ? "Revert Candidate"
                                                      : "Delete Candidate"
                                                  }
                                                >
                                                  <i
                                                    className={
                                                      roles.deleted == 1
                                                        ? "ti ti-arrow-back-up"
                                                        : "ti ti-trash"
                                                    }
                                                  ></i>
                                                </Link>

                                                <button
                                                  onClick={(e) => {
                                                    e.stopPropagation(); // prevent backdrop from closing immediately
                                                    setOpenDropdownId(
                                                      openDropdownId ===
                                                        roles.role_id
                                                        ? null
                                                        : roles.role_id,
                                                    );
                                                  }}
                                                  title="Add Notes or Files or comments"
                                                  style={{
                                                    background: "none",
                                                    border: "none",
                                                    padding: 0,
                                                    margin: 0,
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  <i className="ti ti-file-plus"></i>
                                                </button>

                                                {openDropdownId ===
                                                  roles.role_id && (
                                                  <ul
                                                    className="dropdown-menu show"
                                                    style={{
                                                      marginRight: "50px",
                                                      zIndex: "999",
                                                    }}
                                                  >
                                                    <li>
                                                      <a
                                                        href="#"
                                                        className="dropdown-item rounded-1"
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                          setShowNotesModal(
                                                            true,
                                                          );
                                                        }}
                                                      >
                                                        <i className="ti ti-notes me-2"></i>
                                                        Add Notes
                                                      </a>
                                                      {showNotesModal && (
                                                        <Suspense
                                                          fallback={
                                                            <div>
                                                              Loading Notes
                                                              Form...
                                                            </div>
                                                          }
                                                        >
                                                          <modals.AddNotesModal
                                                            show={
                                                              showNotesModal
                                                            }
                                                            role={roles}
                                                            candidate_id={id}
                                                            user={user.id}
                                                            onClose={() =>
                                                              setShowNotesModal(
                                                                false,
                                                              )
                                                            }
                                                          />
                                                        </Suspense>
                                                      )}
                                                    </li>
                                                    <li>
                                                      <a
                                                        href="#"
                                                        className="dropdown-item rounded-1"
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                          setShowUploadModal(
                                                            true,
                                                          );
                                                        }}
                                                      >
                                                        <i className="ti ti-folder-open me-2"></i>
                                                        Add Media
                                                      </a>
                                                      {showUploadModal && (
                                                        <Suspense
                                                          fallback={
                                                            <div>
                                                              Loading Upload
                                                              Dialog...
                                                            </div>
                                                          }
                                                        >
                                                          <modals.UploadFileRole
                                                            show={
                                                              showUploadModal
                                                            }
                                                            roleId={
                                                              roles.role_id
                                                            }
                                                            candidateId={id}
                                                            token={token}
                                                            refreshFiles={
                                                              loadData
                                                            }
                                                            onClose={() =>
                                                              setShowUploadModal(
                                                                false,
                                                              )
                                                            }
                                                          />
                                                        </Suspense>
                                                      )}
                                                    </li>
                                                    <li>
                                                      <a
                                                        href="#"
                                                        className="dropdown-item rounded-1"
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                          setSelectedRecordingRoleId(
                                                            roles.role_id,
                                                          );
                                                          setShowRecordingModal(
                                                            true,
                                                          );
                                                        }}
                                                      >
                                                        <i className="ti ti-upload me-2"></i>
                                                        Upload Recording
                                                      </a>
                                                    </li>
                                                  </ul>
                                                )}
                                              </div>
                                            </>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Candidate;
